import React from 'react';
import IconsOffer from '../IconsOffer';
import {
    Title, ResourceContainer, IconContainer,
    ResourceTitle, ResourceDescription, OptionContainer,
    PriceContainer, PriceLabel, PriceValue, PriceOldValue,
    LabelPriceContainer, PriceContainerMobile, PriceContainerDesktop,
    PricesContainer, InputBooleanContainer, GasOptionContainer,
    EnergyResourceContainer, ConfirmButton, ConfirmButtonContainer,
    WarningMessageContainer, Container, Spacer, OptionContainerGradientWrapper,
    OptionContainerTitle, OptionContainerTitleText, MobilePriceExtraLabel, 
    DescriptionDesktop, DescriptionMobile,
} from './style';
import { ReactComponent as OrangePlug } from "../../static/images/orangePlug.svg";
import { ReactComponent as BlueGas } from "../../static/images/blueGas.svg";
import { THEME_COLORS } from '../../styles/theme';
import { InputBoolean } from '../InputBoolean';
import { confirmChangeType, changeOfferSelectType } from '../../reducers/changeOfferType';
import { connect } from 'react-redux';
import { OFFER_TYPE } from '../../reducers/offer';
import { WarningMessage } from '../WarningMessage';

const Component = ({
    energyBio = [], energyMono = [], gas = [], name = '', icon,
    typeSelected,
    isApiRequesting,
    isApiError,
    confirm, selectType
}) => {
    let component = null;
    if (!name) {
        // Offer is loading, insert spinner
    } else {
        component = (
            <Container>
                <IconsOffer icon={icon} />
                <Title>{name}</Title>
                <DescriptionDesktop>Quale opzione vuoi attivare: Energia Monoraria o Bioraria?</DescriptionDesktop>
                <DescriptionMobile>Quale opzione vuoi attivare:<br /> Energia Monoraria o Bioraria?</DescriptionMobile>

                <EnergyResourceContainer>
                    <ResourceContainer>
                        <IconContainer>
                            <OrangePlug />
                        </IconContainer>
                        <ResourceDescription>
                            <ResourceTitle color={THEME_COLORS.orange}>Energia</ResourceTitle> prezzo materia prima
                        </ResourceDescription>
                    </ResourceContainer>
                </EnergyResourceContainer>

                <OptionContainerGradientWrapper
                    isChecked={typeSelected === OFFER_TYPE.mono}
                >
                    <OptionContainer
                        onClick={() => selectType(OFFER_TYPE.mono)}
                    >
                        <InputBooleanContainer>
                            <InputBoolean
                                isChecked={typeSelected === OFFER_TYPE.mono}
                                label="Opzione Monoraria"
                                name=""
                                type="radio"
                                errorText=""
                                isSmall={true}
                                isLabelBold={true}
                                onChange={() => { }}
                            />
                        </InputBooleanContainer>

                        <MobilePriceExtraLabel>Energia</MobilePriceExtraLabel>

                        <PricesContainer>
                            {energyMono.map((e, index) =>
                                <React.Fragment key={e.label}>
                                    <PriceContainerMobile key={e.label} isFirst={index === 0}>
                                        <PriceOldValue isMobile={true}>{e.oldValue}</PriceOldValue>
                                        <LabelPriceContainer>
                                            <PriceLabel isMobile={true}>{e.label}</PriceLabel>
                                            <PriceValue>{e.value}</PriceValue>
                                        </LabelPriceContainer>
                                    </PriceContainerMobile>
                                    <PriceContainerDesktop>
                                        <PriceContainer key={e.label}>
                                            <PriceLabel isMobile={false}>{e.label}</PriceLabel>
                                            <PriceOldValue>{e.oldValue}</PriceOldValue>
                                            <PriceValue>{e.value}</PriceValue>
                                        </PriceContainer>
                                    </PriceContainerDesktop>
                                </React.Fragment>
                            )}
                        </PricesContainer>
                    </OptionContainer>
                </OptionContainerGradientWrapper>


                <OptionContainerGradientWrapper
                    isChecked={typeSelected === OFFER_TYPE.bio}
                >
                    <OptionContainer
                        onClick={() => selectType(OFFER_TYPE.bio)}
                    >
                        <InputBooleanContainer>
                            <InputBoolean
                                isChecked={typeSelected === OFFER_TYPE.bio}
                                label="Opzione Bioraria"
                                name=""
                                type="radio"
                                errorText=""
                                isSmall={true}
                                isLabelBold={true}
                                onChange={() => { }}
                            />
                        </InputBooleanContainer>

                        <MobilePriceExtraLabel>Energia</MobilePriceExtraLabel>

                        <PricesContainer>
                            {energyBio.map((e, index) =>
                                <React.Fragment key={e.label}>
                                    <PriceContainerMobile key={e.label} isFirst={index === 0}>
                                        <PriceOldValue isMobile={true}>{e.oldValue}</PriceOldValue>
                                        <LabelPriceContainer>
                                            <PriceLabel isMobile={true}>{e.label}</PriceLabel>
                                            <PriceValue>{e.value}</PriceValue>
                                        </LabelPriceContainer>
                                    </PriceContainerMobile>
                                    <PriceContainerDesktop>
                                        <PriceContainer key={e.label}>
                                            <PriceLabel isMobile={false}>{e.label}</PriceLabel>
                                            <PriceOldValue>{e.oldValue}</PriceOldValue>
                                            <PriceValue>{e.value}</PriceValue>
                                        </PriceContainer>
                                    </PriceContainerDesktop>
                                </React.Fragment>
                            )}
                        </PricesContainer>
                    </OptionContainer>
                </OptionContainerGradientWrapper>

                {gas.length > 0 &&
                    <GasOptionContainer>
                        <OptionContainerTitle>
                            <OptionContainerTitleText>
                                PER ENTRAMBE LE OPZIONI
                            </OptionContainerTitleText>
                        </OptionContainerTitle>


                        <InputBooleanContainer>
                            <ResourceContainer>
                                <IconContainer>
                                    <BlueGas />
                                </IconContainer>
                                <ResourceDescription>
                                    <ResourceTitle color={THEME_COLORS.blue}>Gas</ResourceTitle> prezzo materia prima
                        </ResourceDescription>
                            </ResourceContainer>
                        </InputBooleanContainer>

                        <PricesContainer justifyContent="flex-end" style={{ marginLeft: '41px' }}>
                            {gas.map(e =>
                                <React.Fragment key={e.label}>
                                    <PriceContainerMobile >
                                        <PriceOldValue isMobile={true}>{e.oldValue}</PriceOldValue>
                                        <LabelPriceContainer>
                                            <PriceLabel isMobile={true}>{e.label}</PriceLabel>
                                            <PriceValue>{e.value}</PriceValue>
                                        </LabelPriceContainer>
                                    </PriceContainerMobile>
                                    <PriceContainerDesktop>
                                        <PriceContainer>
                                            <PriceLabel isMobile={false}>{e.label}</PriceLabel>
                                            <PriceOldValue>{e.oldValue}</PriceOldValue>
                                            <PriceValue>{e.value}</PriceValue>
                                        </PriceContainer>
                                    </PriceContainerDesktop>
                                </React.Fragment>
                            )}
                        </PricesContainer>
                    </GasOptionContainer>
                }

                {isApiError &&
                    <WarningMessageContainer>
                        <WarningMessage
                            text="Errore nel cambiare l'opzione"
                        />
                    </WarningMessageContainer>
                }


                <Spacer />

                <ConfirmButtonContainer>
                    <ConfirmButton
                        mainColor={THEME_COLORS.blueViolet}
                        disabled={typeSelected === null || isApiRequesting}
                        onClick={confirm}
                    >
                        Conferma
            </ConfirmButton>
                </ConfirmButtonContainer>
            </Container>
        );
    }
    return (
        <>
            {component}
        </>
    );
}

export default connect(
    state => {
        return {
            typeSelected: state.changeOfferTypeState.offerTypeSelected,
            isApiRequesting: state.changeOfferTypeState.isApiRequesting,
            isApiError: state.changeOfferTypeState.isApiError,
            isApiSuccess: state.changeOfferTypeState.isApiSuccess,
        }
    },
    dispatch => ({
        selectType: type => dispatch(changeOfferSelectType(type)),
        confirm: () => dispatch(confirmChangeType()),
    })
)(Component);